import React from 'react';

import type { UiEntitySpec } from '../config/uiSpec';

import type { EntityFormScreenProps } from './EntityFormScreen';
import { EntityFormScreen } from './EntityFormScreen';

export interface EntityEditScreenProps extends Omit<EntityFormScreenProps, 'mode'> {
  entitySpec: UiEntitySpec;
  id: string | number;
}

export function EntityEditScreen(props: EntityEditScreenProps): JSX.Element {
  return <EntityFormScreen {...props} mode="edit" />;
}
